<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<header>
<h1 class="topictitle1" id="ep2"><a href="#/nav#nep2"><span class="first_text">Epigraph</span></a></h1>
</header>
<div class="epi_group">
<p class="epigraph">“Humans arose as a fortuitous and contingent outcome of thousands of linked events, any one of which could have occurred differently
               and sent history on an alternative pathway . . .”
            </p>
<p class="epigraph_attribution">—Stephen Jay Gould, evolutionary biologist</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epigraph.vue?66da2aad